var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderBookAllDarkmodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#4ECC79"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9C4.50017 9 9.47073 9 4.50017 9C-0.470392 9 4.5 9 0 9C0 4.02944 4.02944 0 9 0C9 3.375 9 4.02944 9 9Z",
    fill: "#F35B37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 9C18.0002 13.9706 13.9708 18 9.00025 18C8.99985 12.375 9 13.9706 9 9C9 4.02944 9 6.1875 9.00025 0C13.9708 0 18.0002 4.02944 18.0002 9Z",
    fill: "#C1C4C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderBookAllDarkmodeIcon);
export default __webpack_public_path__ + "static/media/order-book-all-darkmode-icon.d666b3e94b33a13da4da71f5affc59e9.svg";
export { ForwardRef as ReactComponent };